import React, { memo } from 'react';

import { convertNumbersToProperFormat } from 'utils/number';
import { IPrintPartProps } from 'store/entity/IPrintTemplatePart';
import {
  PrintSingleTaskConsumer,
  IPrintSingleTaskContext,
} from 'store/context/PrintSingleTaskContext';

import messages from './Messages';
import { SingleTaskPart } from '../styles';

const WeightPart: React.FC<IPrintPartProps<'dueDate' | 'startDate'>> = ({
  item,
  property,
}) => (
  <PrintSingleTaskConsumer>
    {(_: IPrintSingleTaskContext) => {
      const {
        options: { view },
      } = item;

      const showBothKeyValue = view === 'both';
      let showKey = showBothKeyValue;
      let showValue = showBothKeyValue;

      if (!showBothKeyValue) {
        showKey = view === 'key';
        showValue = view === 'value';
      }

      let keyTitle;
      let valueTitle;

      if (showKey) {
        keyTitle = messages.weight;
      }
      if (showValue) {
        valueTitle = convertNumbersToProperFormat(property as number);
      }
      return (
        <SingleTaskPart>
          <span>{showKey && keyTitle}</span>
          <span>{showKey && showValue && ': '}</span>
          <span>{showValue && valueTitle}</span>
        </SingleTaskPart>
      );
    }}
  </PrintSingleTaskConsumer>
);

export default memo(WeightPart);
